module.exports = __webpack_public_path__ + "img/arrow-up-square-fill.a16c95ab.svg";